'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefetch;

var _reduxConnect = require('redux-connect');

function prefetch(cb) {
  return function (component) {
    return (0, _reduxConnect.asyncConnect)([{ promise: cb }]).call(null, component);
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/chemist/dist/helpers/prefetch.js
// module id = 185
// module chunks = 0